<template>
  <div>
    <vx-card ref="card">
      <v-select placeholder="Select a Grade" class="sm:w-1/2 w-full" :options="grades" @search:blur="getSubjects" @search:focus="clearData" v-model="gradeDropdown"/>
      <div v-show="gradeDropdown && gradeDropdown.value" class="mt-5">
        <vs-table stripe ref="subjectTable" class="vs-con-loading__container" single pagination max-items="10" search :data="subjects">
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
              <h3 class="ml-2">Subjects for '{{ gradeDropdown ? gradeDropdown.label : '' }}'</h3>
            </div>
          </div>
          <template slot="thead">
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="description">Description</vs-th>
            <vs-th sort-key="languageName">Language</vs-th>
            <vs-th sort-key="videoName">Assigned Video</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="course" :key="indextr" v-for="(course, indextr) in data">

              <vs-td :data="data[indextr].name">
                {{ course.name }}
              </vs-td>

              <vs-td :data="data[indextr].description">
                {{ course.description }}
              </vs-td>

              <vs-td :data="data[indextr].languageName">
                {{ course.languageName ? course.languageName : 'N/A' }}
              </vs-td>

              <vs-td v-if="!course.videoId">
                <vs-button color="success" size="small" type="flat" @click.stop.prevent="showPopup(course.id)">Add Video</vs-button>
              </vs-td>

              <vs-td v-else>
                <div style="display: flex;align-items: center;">
                  {{ course.videoName }}
                  <vs-button class="ml-3" color="danger" size="small" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="removeVideo(course.id)"/>
                </div>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>

    <vs-popup id="assignVideoPopup" title="Assign Marketing Video" :active.sync="assignVideoViewActive">
      <div>
        <label>Select a Marketing Video</label>
        <v-select placeholder="Search / Select a Video" class="w-full" :options="videos" @search:focus="videoDropdown = 0" v-model="videoDropdown"/>
      </div>
      <div class="vx-row">
        <vs-spacer></vs-spacer>
        <div class="vx-col" style="display: flex;">
          <vs-button :disabled="!videoDropdown" ref="assignButton" class="mt-6 vs-con-loading__container" color="success" icon-pack="feather" icon="icon-check" @click="assignToCourse">Assign to Course</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>

</template>

<script>
  import vSelect from 'vue-select';
  export default {
    components: {
      'v-select': vSelect
    },
    data() {
      return {
        grades: [],
        subjects: [],
        gradeDropdown: 0,
        videoDropdown: 0,
        videos: [],
        assignVideoViewActive: false,
        courseId: 0
      }
    },
    methods: {
      getGrades() {
        var self = this;
        self.showLoadingOnElement("card", 1, "material");

        var onSuccess = response => {
          self.grades = response.data.map((item) => {return {label: item.text, value: item.value} });
        };
        var onFinally = function (){
          self.$vs.loading.close(self.$refs.card.$el);
        };
        
        self.$ajaxGet(self, "CourseClassification/GetSelectList", onSuccess, onFinally);
      },
      getSubjects() {
        const self = this;

        if(self.gradeDropdown && self.gradeDropdown.value){
          self.showLoadingOnElement("subjectTable", 1, "material");

          var onSuccess = function (response) {
            self.subjects = response.data;
          };
          var onFinally = function () {
            self.$vs.loading.close(self.$refs.subjectTable.$el);
          };

          self.$ajaxGet(self, "Course/Marketing/GetList/" + self.gradeDropdown.value, onSuccess, onFinally);
        }
      },
      clearData() {
        var self = this;
        
        self.gradeDropdown = 0;
        self.subjects = [];
      },
      showPopup(courseId) {
        var self = this;

        self.videoDropdown = 0;
        self.courseId = courseId;
        self.assignVideoViewActive = true;
        self.getVideos();
      },
      getVideos() {
        const self = this;

        self.showLoadingOnElement("card", 1, "material");

        var onSuccess = function (response) {
          self.videos = response.data.map((item) => {return {label: item.text, value: item.value} });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.card.$el);
        };

        self.$ajaxGet(self, "Video/GetMarketingList", onSuccess, onFinally);
      },
      assignToCourse() {
        var self = this;

        if (self.videoDropdown && self.videoDropdown.value) {
          self.showLoadingOnElement("assignButton", 0.45, "material");

          var onSuccess = function (response) {
            self.courseId = 0;
            self.videoDropdown = 0;
            self.assignVideoViewActive = false;
            self.getSubjects();
          };
          var onFinally = function () {
            self.$vs.loading.close(self.$refs.assignButton.$el);
          };

          self.$ajaxGet(self, "Course/Marketing/AssignVideo?courseId=" + self.courseId + "&videoId=" + self.videoDropdown.value, onSuccess, onFinally);
        }
      },
      removeVideo(courseId) {
        var self = this;
        self.showLoadingOnElement("subjectTable", 1, "material");

        var onSuccess = function (response) {
          self.getSubjects();
        };

        self.$ajaxGet(self, "Course/Marketing/RemoveVideo/" + courseId, onSuccess);
      },
      showLoadingOnElement(element, scale, type){
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
    },
    mounted() {
      this.getGrades();
    },
  }

</script>
